import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Es contenido discreto?',
    answer: '100% digital y privado, nadie sabrá qué compraste. El cargo en tu tarjeta aparecerá con un nombre genérico.'
  }, {
    question: '¿Cómo accedo después de pagar?',
    answer: 'Tendrás acceso inmediato desde tu celular, tablet o computadora. Recibirás un correo con tus credenciales al instante.'
  }, {
    question: '¿Funciona si llevo años con el problema?',
    answer: 'Sí, el sistema trabaja desde la raíz (la reprogramación mental y el control físico), sin importar cuánto tiempo lleves lidiando con esto.'
  }, {
    question: '¿Y si no me funciona?',
    answer: 'Tienes 7 días de garantía de satisfacción. Si sientes que no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }, {
    question: '¿Es un pago único?',
    answer: 'Sí, es un pago único. No hay suscripciones, ni cobros ocultos, y tendrás acceso de por vida al material.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="relative w-full bg-[#0a0a0a] py-12 md:py-16 overflow-hidden" data-id="element-121">
      <div className="absolute inset-0 z-0" data-id="element-122">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-red-900/10 blur-[120px]" data-id="element-123" />
      </div>

      <div className="relative z-20 max-w-3xl mx-auto px-6" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-125">
          <h2 className="font-display text-3xl md:text-5xl uppercase text-white drop-shadow-[0_0_15px_rgba(220,38,38,0.3)]" data-id="element-126">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-400 mt-2" data-id="element-127">
            Resolvemos tus dudas antes de empezar
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-128">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className={`border ${isOpen ? 'border-red-600/50 bg-black' : 'border-red-900/30 bg-[#0a0a0a]/80'} rounded-lg overflow-hidden transition-colors duration-300`} data-id="element-129">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-130">
                  <span className={`font-semibold text-sm md:text-base ${isOpen ? 'text-white' : 'text-gray-300'}`} data-id="element-131">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-red-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-132" />
                </button>
                <AnimatePresence data-id="element-133">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-134">
                      <div className="px-5 pb-5 text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-135">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}